import React, { useEffect, useState } from "react";
import { Container, ContainerView } from "../../components/Container";
import { TitlePage } from "../../components/Layout";
import { useApp } from "../../contexts";
import {
  BalanceContainer,
  BalanceIcon,
  BalanceText,
  BalanceTitle,
  BalanceValue,
  BalanceValueBTC,
  CellRowImage,
  CellRowValue,
  CreateContainer,
  EqualIcon,
  EyeIcon,
  NoEyeIcon,
} from "../wallet-list/styles";
import { formatCurrency, getWalletMLM, roundNumber } from "../../services/app";
import { FormButton } from "../../components/Form";
import { useNavigate } from "react-router";
import { ContainerTable, TableView } from "../../components/Table";
import { CountryCode } from "../../constants";

const defaultValueMLM = {
  possibleBalanceSZT: 0,
  frozenBalanceSZT: 0,
};

const Commission = () => {
  const {
    T,
    formatLocalCurrency,
    convertToBTC,
    convertToLocalCurrency,
    getCurrency,
    user,
  } = useApp();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [dataMLM, setDataMLM] = useState(defaultValueMLM);
  const columns = [
    {
      title: T("Coin"),
      dataIndex: "coin",
      key: "coin",
      sorter: (a, b) => a.coin.toString().localeCompare(b.coin),
      render: (text, record, index) => {
        return (
          <CellRowImage>
            <img
              alt=""
              style={{ width: 32, height: 32 }}
              src={`/assets/images/otc/crypto/${text?.toLowerCase()}.svg`}
            />
            <span>{text}</span>
          </CellRowImage>
        );
      },
    },
    {
      title: T("Amount"),
      dataIndex: "amount",
      key: "amount",
      render: (text, record, index) => {
        return !visible ? "********" : formatCurrency(text, 8, getCurrency());
      },
    },
    {
      title: T("BTC Value"),
      dataIndex: "btc",
      key: "btc",
      align: "right",
      className: "btc-value",
      render: (text, record, index) => {
        return !visible ? (
          "********"
        ) : (
          <CellRowValue
          >
            <div className="flex flex-col gap-1 items-end">
              <p>{formatCurrency(text, null, getCurrency())}</p>
              <span>
                <EqualIcon />{" "}
                {formatLocalCurrency(record.local)}
              </span>
            </div>
          </CellRowValue>
        );
      },
      sorter: (a, b) => parseFloat(a.btc) - parseFloat(b.btc),
    },
  ];

  const convertData = () => {
    return [
      {
        coin: "SZT",
        amount: dataMLM.frozenBalanceSZT + dataMLM.possibleBalanceSZT,
        btc: convertToBTC(
          dataMLM.frozenBalanceSZT + dataMLM.possibleBalanceSZT,
          "SZT",
          getCurrency()
        ),
        local: convertToLocalCurrency(
          dataMLM.frozenBalanceSZT + dataMLM.possibleBalanceSZT,
          "SZT",
          getCurrency()
        ),
      },
    ];
  };

  const convertBalance = () => {
    return convertToLocalCurrency(
      dataMLM.frozenBalanceSZT + dataMLM.possibleBalanceSZT,
      "SZT",
      getCurrency()
    );
  };

  const onConvert = () => {
    navigate(`/commission-detail`);
  };

  const handleGetWalletMLM = async () => {
    try {
      const data = await getWalletMLM();
      setDataMLM(data?.data?.data || defaultValueMLM);
    } catch (error) {
      console.log(error);
    }
  };

  const onDetail = (type, id, record) =>
    user?.country_code === CountryCode.indo
      ? navigate(`/commission-detail`)
      : null;

  useEffect(() => {
    navigate(-1)
    handleGetWalletMLM();
  }, []);
  return <div></div>
};

export default Commission;
